import React, { useState } from 'react'

import Modal from '@mui/material/Modal'
import ArrowForward from '@mui/icons-material/ArrowForward'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import IconButton from 'components/atomic/atoms/icon-button'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'
import Image from 'next/image'
import { Card } from '@mui/material'

const steps = [
    {
        title: 'Benvenut* su Devv 👋',
        subtitle: 'Il luogo dove diventi un supereroe della programmazione!',
        image: '/assets/modals/welcome-1.png',
    },
    {
        title: 'Scegli il percorso giusto per i tuoi obiettivi',
        subtitle:
            'Vuoi imparare a programmare? Iniziare una carriera nel tech o imparare una nuova skill? Abbiamo il percorso giusto per te!',
        image: '/assets/modals/welcome-2.png',
    },
    {
        title: 'Iscriviti o entra in lista',
        subtitle:
            'Iscriviti per avere accesso a tutti i contentuti. Il percorso non è ancora disponibile? Entra in lista ed assicurati un posto!',
        image: '/assets/modals/welcome-3.png',
    },
    {
        title: 'Moooooolto più di un semplice videocorso 🤩',
        subtitle:
            'Dentro ogni percorso trovi lezioni pratiche, progetti reali, video entusiasmanti, articoli e molto altro',
        image: '/assets/modals/welcome-4.png',
    },
    {
        title: 'Raggiungi i tuoi obiettivi e ottieni un certificato.',
        subtitle:
            'Sei pronto per diventare un supereroe della programmazione? Allora inizia ora e dimostra al mondo di cosa sei capace 🚀',
        image: '/assets/modals/welcome-5.png',
    },
]

const Hero = styled('div')`
    position: relative;
    height: 300px;
`

const ModalContent = styled(Card)`
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    max-width: 90%;
    transform: translate(-50%, -40%);
    background-color: ${({ theme }) => theme.palette.background.paper};
    box-shadow: 24px;
    border-radius: 20px;
    border: 5px solid #262c3230;
    min-height: 500px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`

interface WelcomeModalProps {
    open: boolean
    onClose: () => void
}

const WelcomeModal = (props: WelcomeModalProps) => {
    const [activeStep, setActiveStep] = useState(0)
    const { t }: I18n = useTranslation()

    const handleNext = () => {
        if (activeStep === steps.length - 1) handleClose()
        else setActiveStep((prevActiveStep) => prevActiveStep + 1)
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const handleClose = () => {
        if (props.onClose) props.onClose()
    }

    return (
        <Modal
            open={props.open || true}
            onClose={handleClose}
            disableAutoFocus={true}
            slotProps={{ backdrop: { style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } } }}>
            <ModalContent>
                <Hero>
                    <Image
                        src={steps[activeStep].image}
                        alt={`Welcome modal step ${activeStep + 1}`}
                        style={{ width: '100%', position: 'absolute', top: 0, left: 0 }}
                        objectFit="cover"
                        layout="fill"
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            padding: '1rem',
                            justifyContent: 'flex-end',
                        }}>
                        <IconButton aria-label="Close modal" icon="close" onClick={handleClose} color="inherit" />
                    </Box>
                </Hero>

                <Stack alignItems="center" padding={2}>
                    <Text variant="h4" style={{ textAlign: 'center' }}>
                        {steps[activeStep].title}
                    </Text>

                    <Text variant="subtitle1" style={{ marginTop: '1rem', textAlign: 'center' }}>
                        {steps[activeStep].subtitle}
                    </Text>

                    <Box mt={3} sx={{ display: 'flex', justifyContent: 'center', width: { md: '50%' } }}>
                        {activeStep !== 0 && (
                            <Button fullWidth variant="outlined" onClick={handleBack} sx={{ mr: 1 }}>
                                {t('common:welcomeModal.previosButton')}
                            </Button>
                        )}
                        <Button fullWidth variant="contained" onClick={handleNext} endIcon={<ArrowForward />}>
                            {activeStep === 0
                                ? t('common:welcomeModal.getStartedButton')
                                : activeStep === steps.length - 1
                                ? t('common:welcomeModal.finishButton')
                                : t('common:welcomeModal.nextButton')}
                        </Button>
                    </Box>
                </Stack>
            </ModalContent>
        </Modal>
    )
}

export default WelcomeModal
